<template>
  <div>
    <Form class="m-t-20" :model="user" :label-width="80" :labelWidth="150" label-position="right" :rules="rules">
      <FormItem label="昵称：" prop="nickName">
        <Input v-model="user.extNickName" placeholder="请输入用户昵称" style="width:50%"></Input>
      </FormItem>
      <FormItem label="性别：">
        <Select placeholder="请选择性别" v-model="user.extSex" style="width:50%">
          <Option v-for="(value,key) in userForm.sex" :key="key" :value="key">{{value}}</Option>
        </Select>
      </FormItem>
      <FormItem label="真实姓名：">
        <Input v-model="user.trueName" placeholder="请输入真实姓名" style="width:50%"></Input>
      </FormItem>
      <FormItem label="设置密码：">
        <Input type="password" v-model="user.setPass" placeholder="请输入密码" style="width:50%"></Input>
      </FormItem>
      <FormItem label="确认密码：">
        <Input type="password" v-model="user.checkPass" placeholder="请确认密码" style="width:50%"></Input>
      </FormItem>
      <FormItem label="上传头像：">
        <PhotoUpload v-model="user.extPhotoHeadOss" :success="photoHeadSuccess"></PhotoUpload>
      </FormItem>
    </Form>
  </div>
</template>

<script>
  import {PhotoUpload} from '@/components/libs'
  import {dict} from '@/libs'

  export default {
    name: 'EditUserInfo',
    data() {
      return {
        rules: {},
        userForm: {
          sex: {},
          photoHead: {
            name: 'photoHead',
            param: {
              makeMd5Name: true,
              ossPath: 'society/client/user/:SPLIT:' + this.$store.state.custom.user.id + '/'
            },
            success: (payload, file) => Object.assign(this.user, {photoHead: payload.ossPath}),
            single: true,
            list: []
          },
          setPass: '',
          checkPass: ''
        }
      }
    },
    props: {
      user: {type: Object, required: true},
      setPass: {type: String},
      checkPass: {type: String}
    },
    updated() {
      if (this.user.photoHead) {
        this.userForm.photoHead.list = [{name: this.user.photoHead, url: this.user.photoHead}]
      }
    },
    components: {PhotoUpload},
    methods: {
      photoHeadSuccess(data) {
        console.log(data)
      }
    },
    created() {
      dict.dict('DictGb_personSex').then(payload => this.userForm.sex = payload.content)
    }
  }
</script>